<template>
  <div class="col-md-4 dragme" v-if="data.access > 2">
    <div class="portlet light">
      <i class="fa fa-arrows-alt arrow-move" aria-hidden="true"></i>
      <div class="module-name">Caseload Summary</div>
      <div class="portlet-title">
        <div class="caption caption-md">
          <i class="icon-bar-chart font-dark hide"></i>
          <span class="caption-subject font-dark bold uppercase">Caseload Summary</span>
        </div>
      </div>
      <div class="portlet-body" style="height: 300px; overflow: hidden;" v-bar>
        <div class="table-scrollable table-scrollable-borderless" v-if="data.access > 3">
          <table class="table table-hover table-light">
            <thead>
            <tr class="uppercase">
              <th> CASE MANAGER </th>
              <th> CASES </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(n, key, idx) in data.caseload_summary">
              <td>
                <router-link
                  :to="{
                    name: 'Participant Directory Search',
                    params: {
                      query: {
                        case: n.fullName
                      }
                    }
                  }"
                  tag="a">
                  {{ n.fullName }}
                </router-link>
              </td>
              <td>
                <span> {{ n.total }} </span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="table-scrollable table-scrollable-borderless" v-else>
          <table class="table table-hover table-light">
            <thead>
            <tr class="uppercase">
              <th> STATUS </th>
              <th> CASES </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(n, key, idx) in data.caseload_summary">
              <td>
                <router-link
                  :to="{
                    name: 'Participant Directory Search',
                    params: {
                      query: {
                        case: `${data.first_name} ${data.last_name}`,
                        status: key
                      }
                    }
                  }"
                  tag="a">
                  {{ key }}
                </router-link>
              </td>
              <td>
                <span> {{ n }} </span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';
  export default {
    props: ['mode'],

    data() {
      return {
        status: ['Active', 'Follow-Up', 'Pending', 'Waitlist']
      }
    },
    computed: {
      ...mapGetters({
        data: 'getOrganizationDashboard'
      }),
    },
  }
</script>
<style scoped>
  .dragme .table-scrollable {
    margin-top:-10px !important;
  }
</style>



// WEBPACK FOOTER //
// CaseloadSummary.vue?0587930e